"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StepLayout = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _utils = require("../../utils");
var _CircularImageButton = require("../../components/CircularImageButton");
var _KeyboardObserver = require("../../components/KeyboardObserver");
var _styles = _interopRequireWildcard(require("./styles"));
var _jsxFileName = "/home/circleci/wellth/packages/ui/src/layout/StepLayout/index.tsx";
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        "default": e
      };
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]);
    return f;
  })(e, t);
}
var StepLayout = exports.StepLayout = function StepLayout(_ref) {
  var _ref$renderSubmitButt = _ref.renderSubmitButton,
    renderSubmitButton = _ref$renderSubmitButt === void 0 ? true : _ref$renderSubmitButt,
    submit = _ref.submit,
    children = _ref.children,
    style = _ref.style,
    backgroundColor = _ref.backgroundColor,
    buttonProps = _ref.buttonProps;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var cancellablePromise = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    return function () {
      if (cancellablePromise.current) {
        cancellablePromise.current.cancel();
      }
    };
  }, []);
  var onSubmitPress = (0, _react.useCallback)((0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          setIsLoading(true);
          cancellablePromise.current = (0, _utils.makeCancellable)(submit());
          _context.prev = 1;
          _context.next = 2;
          return cancellablePromise.current.promise;
        case 2:
          _context.prev = 2;
          setIsLoading(false);
          return _context.finish(2);
        case 3:
          cancellablePromise.current = null;
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1,, 2, 3]]);
  })), [setIsLoading, submit]);
  return _react["default"].createElement(_KeyboardObserver.KeyboardObserver, {
    style: style,
    backgroundColor: backgroundColor,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 5
    }
  }, function (keyboardIsVisible) {
    return _react["default"].createElement(_reactNative.SafeAreaView, {
      style: _styles["default"].safeArea,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 62,
        columnNumber: 9
      }
    }, typeof children === "function" ? children(keyboardIsVisible) : children, renderSubmitButton ? _react["default"].createElement(_CircularImageButton.CircularImageButton, (0, _extends2["default"])({
      containerStyle: _styles["default"].submitButton,
      size: _styles.BUTTON_SIZE
    }, buttonProps, {
      onPress: onSubmitPress,
      loading: isLoading,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 13
      }
    })) : null);
  });
};
var _default = exports["default"] = StepLayout;